module.exports = __webpack_public_path__ + "static/media/600_x_314.d01b1ec6.png";